import { onUnreadCountChange, show } from "@intercom/messenger-js-sdk";

/**
 * Opens the Intercom messenger.
 *
 * The SDK caches `window.Intercom` into a module-level ref on the first SDK
 * call (here, `onUnreadCountChange` on mount), which happens before the widget
 * script finishes loading. That locks the ref to the temporary queue stub, so
 * the SDK's `show()` later pushes onto a queue nobody drains. Calling the live
 * `window.Intercom` directly sidesteps the stale ref; we keep `show` as a
 * fallback in case the global isn't ready yet.
 *
 * @returns {void}
 */
function openIntercom(): void {
  if (typeof window !== "undefined" && typeof window.Intercom === "function") {
    window.Intercom("show");
  } else {
    show();
  }
}
import { Badge, Sheet, Tooltip } from "@mui/joy";
import { CurrentUserSelector } from "@nerdjs/account-kit";
import { useEffect, useState } from "react";
import { useAppSelector } from "../hooks";

/**
 *
 * @returns {ReactElement} IntercomButton page
 */
export function IntercomButton() {
  const currentUser = useAppSelector(CurrentUserSelector);
  const [messageCount, setMessageCount] = useState(0);

  useEffect(() => {
    onUnreadCountChange((unreadCount: number) => {
      setMessageCount(unreadCount);
    });
  }, []);

  if (!currentUser) return null;

  return (
    <Tooltip
      title="Need help?"
      enterDelay={0.2}
      size="sm"
      arrow
      variant="outlined"
      placement="left"
    >
      <Sheet
        color="primary"
        variant="solid"
        id="Intercom"
        onClick={openIntercom}
        style={{ zIndex: 99999 }}
        sx={{
          position: "fixed",
          cursor: "pointer",
          bottom: "0px",
          right: "0px",
          width: 34,
          height: 34,

          borderTopLeftRadius: "12px",
          display: "flex",
          background: "#ffc107",
          alignItems: "center",
          justifyContent: "center",
          transformOrigin: "right bottom",
          transition: `transform 167ms cubic-bezier(0.33, 0, 0, 1)`,
          "&:hover": {
            transform: "scale(1.4)",
          },
        }}
      >
        <Badge
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          color="danger"
          size="sm"
          badgeInset={-6}
          badgeContent={messageCount}
        >
          <i
            style={{ fontSize: 21, color: "#4E2E00" }}
            className="fa-brands fa-intercom"
          />
        </Badge>
      </Sheet>
    </Tooltip>
  );
}
